import { useAuthImage } from '../hooks/useAuthImage';

function AuthImage({ filename, alt, style, refreshTick }) {
    const src = useAuthImage(filename, refreshTick);

    if (!src) return null;

    return <img src={src} alt={alt} style={style} />;
}

export default AuthImage;
